/* COMPONENT - C09.02 Language Footer */
"use strict";
var $ = require("jquery");
var parsley = require("parsleyjs");

export default class DonateWidget {
  constructor(element) {
    this.root = element;
    this.dynamicHeader = this.root.querySelector(
      ".js-donation-form-dynamic-header"
    );
    this.frequencyTabs = this.root.querySelectorAll(
      ".js-donation-form-frequency"
    );
    this.moneyRadioButtons = this.root.querySelectorAll(
      ".js-donation-form-money-radio"
    );
    this.defaultMoneyRadioButton = this.root.querySelector("#money2");
    this.selectedMoneyRadioButton = this.root.querySelector(
      ".js-donation-form-money-radio:checked"
    );
    this.selectedFrequencyRadioButton = this.root.querySelector(
      ".js-donation-form-frequency input:checked"
    );
    this.frequencyRadioButtons = this.root.querySelectorAll(
      ".js-donation-form-frequency-radio"
    );
    this.otherAmountInput = this.root.querySelectorAll(
      ".js-donation-form-other-amount"
    );
    this.buttonsOnce = this.root.querySelector(".js-once");
    this.buttonsMonthly = this.root.querySelector(".js-monthly");

    this.otherAmount = this.root.querySelectorAll(".js-donation-other-amount");

    this.frequencyWraps = this.root.querySelectorAll(
      ".js-donation-form-frequency-wrap"
    );
    this.bindEvents();
    this.setDefaults();
    this.parsleySetup(this.root);
  }

  parsleySetup(element) {
    var parsleyConfig = {
      errorsContainer: function (pEle) {
        var $err;
        $err = $(element).find(".form-errors");
        return $err;
      },
      errorsWrapper: '<ul class="form-errors__list"></ul>',
      excluded: "input[type=hidden], [disabled], :hidden, [hidden]",
      trigger: "focusout",
      focus: "none",
    };
    $(this.root).parsley(parsleyConfig);
  }

  setTitles(event) {
    this.dynamicHeader.textContent = event.getAttribute("data-related-title");
  }

  toggleFrequencyVisibility(radio) {
    const targetSelector = radio.getAttribute("data-target");
    const targets = this.root.querySelectorAll(`.${targetSelector}`);
    const defaultAmount = radio.getAttribute("data-default-amount");

    this.moneyRadioButtons.forEach(function (button) {
      button.setAttribute("checked", false);
    });

    this.frequencyWraps.forEach((el) => (el.hidden = true));

    targets.forEach(function (obj) {
      obj.hidden = false;
      const defaultRadio = obj.querySelector(`input[value="${defaultAmount}"]`);

      if (defaultRadio) {
        defaultRadio.click();
      }
    });
  }

  handleFrequencyRadioChangeEvent(e) {
    this.toggleFrequencyVisibility(e.target);
  }

  handleMoneyRadioChangeEvent(ev) {
    const radio = ev.target;
    let otherAmountInput = "";
    if (radio.getAttribute("aria-controls")) {
      otherAmountInput = document.getElementById(
        radio.getAttribute("aria-controls")
      );
      otherAmountInput.hidden = false;
    } else {
      this.otherAmount.forEach(function (obj) {
        obj.hidden = true;
      });
    }

    this.otherAmountInput.forEach(function (obj) {
      obj.value = "";
      obj.setAttribute("required", false);
      $(obj).parsley().reset();
    });

    this.setTitles(radio);
  }

  bindEvents() {
    this.frequencyRadioButtons.forEach(function (o) {
      o.addEventListener(
        "change",
        this.handleFrequencyRadioChangeEvent.bind(this)
      );
    }, this);

    this.moneyRadioButtons.forEach(function (o) {
      o.addEventListener("change", this.handleMoneyRadioChangeEvent.bind(this));
    }, this);
  }

  setDefaults() {
    this.setTitles(this.selectedMoneyRadioButton);
    this.toggleFrequencyVisibility(this.selectedFrequencyRadioButton);
  }

  submitForm() {
    this.root.submit();
  }
}
